export const servicesContent = {
  es: {
    kicker: "Servicios",
    allLabel: "Todos los servicios",
    cta: "Agendá una llamada",
    activateTitle: "¿Querés activar este servicio?",
    fee: {
      label: "Un único fee mensual",
      amount: "USD 3.200",
      per: "/mes",
      checks: ["Sin retainer ni permanencias mínimas.", "Equipo completo, listo para operar.", "+8 estrategias ejecutando sincronizadas.", "Herramientas, procesos y reporting incluidos."],
      cta: "Quiero mi revisión estratégica",
    },
    labels: { objetivo: "Objetivo", incluye: "Incluye", noIncluye: "No incluye", areas: "Las cuatro gerencias + Dirección", areasIntro: "Cada área tiene sus propias estrategias, entregables y alcance, todas alineadas bajo una misma Dirección de Negocios para que el conjunto avance como un solo ecosistema y no como iniciativas sueltas.", orgHint: "Tocá cada área para ver qué incluye", anterior: "Anterior", siguiente: "Siguiente" },
    comingSoon: "Estamos preparando el detalle de este servicio. Escribinos para conocer el alcance completo.",
    list: [
      {
        slug: "direccion-de-negocios",
        shortName: "Dirección de Negocios",
        name: "Dirección de Negocios B2B as a Service",
        badge: "Ecosistema Mínimo Viable B2B",
        titleMain: "Dirección de Negocios",
        titleAccent: "B2B as a Service",
        intro: "Un equipo senior, un mismo objetivo: acelerar tu crecimiento B2B sin tener que construir toda la estructura desde cero.",
        stats: [
          { icon: "users", label: "+15 profesionales" },
          { icon: "layers", label: "4 gerencias" },
          { icon: "compass", label: "Dirección de Negocios" },
          { icon: "cpu", label: "Stack tecnológico" },
        ],
        phases: {
          title: "Cómo madura en el tiempo",
          intro: "Lo que se siembra el primer día madura en el corto, el mediano y el largo plazo.",
          items: [
            { icon: "zap", term: "Corto plazo", title: "Activación", text: "Rompemos la inercia: todas las iniciativas salen en paralelo en los primeros 15 días, con un primer ciclo de ajuste y resultados visibles." },
            { icon: "chart", term: "Mediano plazo", title: "Optimización", text: "Aparecen las primeras señales de cada estrategia. Iteramos con feedback real: mejores indicadores, pipeline más avanzado y primeras apariciones en motores de IA." },
            { icon: "trending", term: "Largo plazo", title: "Escalabilidad", text: "Todo más ordenado y con métricas concretas: sabemos qué funciona más y dónde conviene invertir para seguir revisando el proceso." },
          ],
        },
        callouts: [
          { icon: "sparkles", title: "El aprendizaje queda", text: "La ejecución construye indicadores propios, entendimiento real del mercado y un ciclo de iteración mes a mes. Cada frente mejora con el tiempo en lugar de arrancar de cero." },
          { icon: "compass", title: "Una sola dirección, un único fee", text: "Todo corre en paralelo y coordinado, no como iniciativas sueltas. Un único fee cubre el frente comercial completo; el cliente decide qué activar y qué complementar con su equipo." },
        ],
        rhythm: {
          title: "Visibilidad y ritmo de trabajo",
          text: "Todo el ecosistema corre con visibilidad total en tiempo real:",
          items: [
            "Comunicación diaria con el equipo",
            "Reuniones ad hoc cuando hace falta destrabar algo puntual",
            "Reportes semanales de actividad",
            "Encuentros quincenales para iterar la estrategia junto al cliente",
            "Reunión mensual de reporting: resultados y próximos pasos",
          ],
        },
        areas: [
          {
            icon: "compass",
            name: "Dirección de Negocios",
            objetivo:
              "Sostener la estrategia comercial B2B como un todo: que las cuatro gerencias avancen alineadas bajo un mismo criterio, que el conjunto tenga sentido de principio a fin y que la dirección se ajuste con lo que el mercado va mostrando.",
            incluye: [
              "Revisión constante de que cada frente avance y de que ninguno quede desatendido",
              "Alineación entre gerencias para que nada compita ni se pise entre sí",
              "Análisis de mercado, competencia y tendencias de la industria",
              "Detección de gaps y oportunidades no cubiertas",
              "Evaluación de nuevas estrategias a medida que el negocio o el contexto lo piden",
              "Ajuste de la estrategia general junto al cliente en los encuentros quincenales",
              "Comunicación diaria con el equipo",
              "Reuniones ad hoc cuando hace falta destrabar algo puntual",
              "Reportes semanales de actividad",
              "Reunión mensual de reporting: resultados y próximos pasos",
            ],
            noIncluye:
              "Definir el rumbo estratégico de la empresa ni sus objetivos de negocio más macro: eso sigue siendo responsabilidad de la empresa.",
          },
          {
            icon: "target",
            name: "Gerencia de Desarrollo de Negocios ABM",
            objetivo:
              "Generar y gestionar oportunidades comerciales B2B de forma sistemática, combinando prospección outbound multicanal con gestión de demanda inbound.",
            incluye: [
              "Scraping y enrichment de bases",
              "Prospección multicanal (LinkedIn, email, WhatsApp): +400 contactos nuevos por mes y meta de 2.000 contactos únicos en 6 meses",
              "Gestión de hasta 50 leads inbound por mes, incluyendo lo que llega por contenido, marketing y SEO",
              "Documentación de procesos, bases de datos y activos como dominios comprados",
              "Reporting semanal de actividad y resultados",
              "Gestión de todas las conversaciones hasta llegar a la reunión",
              "Registro de todas las conversaciones",
              "Armado de briefs para la reunión",
            ],
            noIncluye:
              "Llamadas en frío, participación en reuniones comerciales ni cierre de oportunidades: esas instancias siguen siendo responsabilidad del equipo comercial del cliente.",
            note: {
              label: "Queda en la empresa",
              text: "Todo lo que se documenta, construye o compra en esta gerencia (procesos, bases de datos, dominios) es un activo del cliente, no de Narwhal.",
            },
          },
          {
            icon: "megaphone",
            name: "Gerencia de Comunicación y Posicionamiento",
            objetivo:
              "Acompañar el desarrollo comercial con contenido que construya claridad, confianza y soporte real a la venta en ciclos largos con múltiples decisores, y sostener presencia de marca en buscadores y motores de IA. No reemplaza al equipo de marketing del cliente ni define la estrategia global de marca.",
            incluye: [
              "Definición de ejes de comunicación alineados al ICP y a la propuesta de valor, con keywords para posicionar en buscadores y motores de IA",
              "Un one-pager comercial",
              "2 blog posts estratégicos por mes, publicados en la web y en LinkedIn",
              "Una newsletter mensual por email y una en LinkedIn, republicada en el blog",
              "4 a 6 piezas mensuales para LinkedIn corporativo y 4 a 6 para el perfil de un referente comercial",
              "Videos subidos a YouTube como parte del posicionamiento y republicados en Meta",
              "Apoyo de diseño para piezas puntuales (PPTs comerciales, brochures, edición de video) según disponibilidad",
              "Monitoreo de prompts en ChatGPT, Gemini y Perplexity: cómo y cuándo aparece la marca y a quién recomiendan",
              "Pedidos on-demand (flyers, infografías, casos de éxito) con 15 días de anticipación",
            ],
            noIncluye:
              "Producción audiovisual profesional avanzada, gestión activa de engagement (respuestas, comentarios, DMs) ni estrategia de branding institucional de largo plazo.",
            note: {
              label: "Alcance",
              text: "Es una estrategia deliberadamente acotada, sostenida en tendencias y presencia constante, no una campaña de branding institucional de gran escala. El apoyo de diseño depende de la disponibilidad del equipo, pero cubre bien la demanda básica.",
            },
          },
          {
            icon: "chart",
            name: "Gerencia de Marketing ABM",
            objetivo:
              "Reforzar presencia, capturar señales de intención y acelerar oportunidades mediante campañas pagas segmentadas y una base técnica de SEO sólida. No genera volumen indiscriminado de leads ni reemplaza la venta.",
            incluye: [
              "Estrategia de medios alineada al ICP y a la narrativa comercial",
              "Configuración y validación de píxeles, Google Analytics y eventos de conversión",
              "Integración de tracking con CRM",
              "Campañas en Meta Ads (captación y remarketing) y Google Ads (Performance Max y Search, incluyendo términos de competidores)",
              "Hasta 8 campañas activas en simultáneo",
              "5 creatividades gráficas y 3 videos cortos",
              "Mejoras técnicas de SEO (schemas, FAQs, ajustes de landings)",
              "Seguimiento de métricas vía Google Analytics y Search Console",
              "Revisión quincenal y reporte mensual",
            ],
            noIncluye:
              "LinkedIn Ads (se cotiza aparte), generación masiva de leads sin calificación, branding de gran escala ni SEO avanzado (backlinks, autoridad de dominio a gran escala): el foco es una base técnica sólida. La inversión en medios (USD 300 a 500 mensuales recomendados) corre por cuenta del cliente y no está incluida en el fee.",
          },
          {
            icon: "cpu",
            name: "Gerencia de Tech, Datos & Performance",
            objetivo:
              "Asegurar que todo el ecosistema comercial digital esté habilitado, configurado, medido y funcionando sin fricción, para que el resto de las gerencias ejecute con visibilidad real. No reemplaza al equipo técnico o de sistemas del cliente.",
            incluye: [
              "Revisión y orden de dominio, entorno web, certificados de seguridad y puntos de contacto (formularios, chat, WhatsApp, widgets)",
              "Gestión y configuración de licencias tecnológicas clave (CRM, automatización, outreach)",
              "Conexión y validación de dominios, cuentas de email y accesos",
              "Monitoreo continuo para detectar oportunidades y riesgos",
              "Mejoras chicas en la web cuando hacen falta",
            ],
            noIncluye:
              "Ejecución de proyectos técnicos de gran escala: el rol es monitorear y ordenar, no construir infraestructura desde cero.",
          },
        ],
      },
      {
        slug: "comunicacion-institucional",
        shortName: "Autoridad & Contenido",
        name: "Autoridad, Contenido & Presencia Digital",
        badge: "Módulo 2",
        variant: "authority",
        titleMain: "Autoridad, Contenido",
        titleAccent: "& Presencia Digital",
        intro: "Potenciamos lo construido en la Capa 1, aumentando frecuencia, profundidad y formatos para convertir la comunicación de la empresa en un activo de autoridad.",
        intro2: "A partir del conocimiento generado, ampliamos la estrategia para construir mayor presencia, reconocimiento y confianza en el mercado.",
        subcopy: "Más contenido. Más formatos. Más impacto. Para que tu empresa sea más visible, reconocida y confiable en el mercado.",
        heroCta: "Quiero potenciar mi presencia",
        floatLabels: ["Contenido", "Formatos", "Activos", "Tendencias", "Autoridad"],
        heroNote: "Del conocimiento interno al reconocimiento del mercado.",
        complement: {
          kicker: "Cómo se complementa",
          layers: [
            { tag: "Capa 1", title: "Desarrollo Comercial", text: "Genera conversaciones y oportunidades en el corto plazo." },
            { tag: "Capa 2", title: "Autoridad, Contenido & Presencia", text: "Construye una presencia más fuerte y confiable que potencia cada oportunidad." },
          ],
        },
        scope: {
          kicker: "Nuestro alcance",
          title: "Más contenido. Más profundidad. Más valor.",
          intro: "Evolucionamos la estrategia de contenido para construir una presencia más sólida, con mayor impacto y relevancia en el mercado.",
          columns: [
            {
              icon: "file",
              title: "Evolución de contenido",
              text: "Pasamos de una presencia constante a una estrategia de contenido más profunda y sofisticada.",
              items: ["Mayor frecuencia de publicación", "Nuevas narrativas y formatos", "Contenido audiovisual", "Piezas de mayor profundidad", "Adaptación del contenido a cada canal"],
            },
            {
              icon: "layers",
              title: "Activos de autoridad",
              text: "Transformamos conocimiento interno en recursos que fortalecen la percepción de expertise.",
              items: ["Whitepapers", "Guías descargables", "Casos de éxito", "Estudios e informes propios", "Materiales de referencia para el mercado"],
            },
            {
              icon: "trending",
              title: "Always On & Tendencias",
              text: "Construimos una presencia activa y proactiva frente a las conversaciones relevantes del mercado.",
              items: ["Identificación de tendencias", "Nuevas oportunidades de contenido", "Participación en temas estratégicos", "Reacción rápida frente a acontecimientos relevantes", "Evolución continua de la narrativa"],
            },
          ],
        },
        result: {
          kicker: "El resultado",
          title: "De comunicar a construir autoridad.",
          text: "Una presencia más frecuente, profunda y estratégica que aumenta la confianza del mercado y fortalece cada oportunidad comercial.",
          cards: [
            { icon: "users", title: "Mayor reconocimiento de marca" },
            { icon: "shield", title: "Más confianza en el mercado" },
            { icon: "chart", title: "Más impacto en cada oportunidad" },
          ],
          cta: "Quiero potenciar mi presencia",
        },
      },
      {
        slug: "seo-geo-aeo",
        shortName: "SEO / GEO / AEO",
        name: "SEO / AEO / GEO + Autoridad Digital",
        badge: "Módulo 3",
        variant: "authority",
        titleMain: "SEO / AEO / GEO",
        titleAccent: "+ Autoridad Digital",
        intro: "Hacemos que tu empresa sea encontrada, entendida y reconocida por buscadores tradicionales y motores de IA.",
        intro2: "Construimos una capa de autoridad digital combinando estrategia SEO, contenido especializado, activos propios y presencia externa para aumentar la visibilidad orgánica y generar nuevas oportunidades.",
        subcopy: "Más visibilidad orgánica. Más autoridad. Más oportunidades.",
        heroCta: "Quiero más visibilidad",
        floatLabels: ["SEO", "AEO", "GEO", "Contenido", "Autoridad"],
        heroNote: "Encontrada, entendida y elegida en Google y en motores de IA.",
        commitment: {
          scope: {
            kicker: "Alcance",
            title: "Qué incluye este módulo",
            subtitle: "Todo lo que ejecutamos para construir autoridad orgánica y presencia en buscadores tradicionales e IA.",
            columns: [
              {
                icon: "search",
                title: "Estrategia SEO / AEO / GEO",
                text: "Dónde competir y cómo construir presencia.",
                items: ["Plan SEO + AEO + GEO trimestral: estrategia, monitoring proactivo, medición, correcciones e iteración constante. Proceso continuo.", "Herramientas de monitoring incluidas."],
              },
              {
                icon: "file",
                title: "Contenido de autoridad",
                text: "Contenido que posiciona y capta demanda.",
                items: ["Blogs estratégicos (unos 40 en el semestre), con un ritmo sostenido y optimizados para búsquedas tradicionales y buscadores de IA."],
              },
              {
                icon: "link",
                title: "Autoridad externa",
                text: "Señales que fortalecen tu dominio.",
                items: ["Trabajo técnico de backlinks y linkbuilding para construir autoridad de dominio de forma sostenida.", "Apertura y optimización de perfiles en Wikipedia, Reddit, Crunchbase, Google My Business y portales relevantes del sector."],
              },
              {
                icon: "settings",
                title: "Web & técnico",
                text: "Infraestructura lista para escalar.",
                items: ["Migración del blog del subdominio al dominio principal para consolidar autoridad SEO.", "Ajustes técnicos web para mejorar performance, velocidad de carga, conversión y experiencia de usuario."],
              },
            ],
          },
          metrics: {
            kicker: "Métricas esperadas",
            title: "Rango estimado mínimo en 6 meses",
            subtitle: "El rango estimado mínimo que proyectamos alcanzar durante el período.",
            cards: [
              { icon: "settings", value: "2", label: "auditorías técnicas completas con fixes y contenido mensual optimizado", sub: "Mes 6" },
              { icon: "search", value: "Hasta 5", label: "competencias monitoreadas y análisis de gaps en AEO/GEO", sub: "Todo el período" },
              { icon: "trending", value: "+60% – 120%", label: "crecimiento de tráfico orgánico web sobre base actual", sub: "Mes 4–6" },
              { icon: "chart", value: "15", label: "keywords nuevas posicionadas en página 1 (mínimo)", sub: "Mes 3–6" },
              { icon: "sparkles", value: "3 – 5", label: "temas clave con apariciones sostenidas en AI Overviews (GEO/AEO)", sub: "Mes 3–5" },
              { icon: "news", value: "30 – 40", label: "blogs indexados con tráfico propio (de 40 publicados)", sub: "Mes 4–6" },
              { icon: "lead", value: "+15% – 30%", label: "mejora en la tasa de conversión web (post ajustes)", sub: "Mes 2–3" },
              { icon: "link", value: "20 – 30", label: "backlinks de calidad generados", sub: "Todo el período" },
              { icon: "check", value: "Completado", label: "migración del blog al dominio principal", sub: "Urgente" },
            ],
          },
          cta: "Quiero más visibilidad",
        },
      },
      {
        slug: "pr-y-eventos",
        shortName: "PR y Eventos",
        name: "PR + Webinars + Community Building",
        badge: "Módulo 4",
        variant: "authority",
        titleMain: "PR + Webinars",
        titleAccent: "+ Community Building",
        intro: "Construimos autoridad institucional y presencia de mercado a través de relaciones públicas, eventos estratégicos y espacios donde participan los referentes de la industria.",
        subcopy: "Más reconocimiento. Más autoridad. Más oportunidades.",
        heroCta: "Quiero construir presencia",
        floatLabels: ["PR", "Medios", "Webinars", "Eventos", "Community"],
        heroNote: "Dónde aparecés, con quién te relacionás y qué lugar ocupás en tu ecosistema.",
        complement: {
          kicker: "Cómo se complementa",
          layers: [
            { tag: "Capa 1", title: "Desarrollo Comercial", text: "La capa comercial genera movimiento y abre conversaciones." },
            { tag: "Capa 2", title: "PR, Eventos & Community", text: "Amplifica el movimiento con presencia y reputación en el mercado." },
          ],
          intro: "En B2B, la confianza no solo se construye con lo que una empresa comunica, sino también con dónde aparece, con quién se relaciona y qué lugar ocupa dentro de su ecosistema. Narwhal desarrolla una estrategia de presencia externa para aumentar reconocimiento, generar oportunidades de exposición y posicionar a la empresa frente a clientes, partners y referentes del sector.",
          caption: "Mientras Desarrollo Comercial abre conversaciones, esta capa aumenta la credibilidad y visibilidad de la empresa dentro del mercado.",
        },
        commitment: {
          scope: {
            kicker: "Alcance",
            title: "Qué incluye este módulo",
            subtitle: "El detalle de todo lo que ejecutamos y gestionamos para construir tu presencia externa.",
            columns: [
              {
                icon: "megaphone",
                title: "PR & Medios",
                text: "Visibilidad en medios relevantes del sector.",
                items: ["Plan de medios: definición de estrategia y medios prioritarios y especializados. Hoja de ruta.", "Narwhal actúa como área interna de PR: scouting de medios afines a la empresa, construcción de base de datos de periodistas y publicaciones relevantes, tableros de seguimiento y gestión activa de vínculos. El costo de publicación en medios pagos no está incluido."],
              },
              {
                icon: "mic",
                title: "Webinars",
                text: "Espacios para posicionar tu expertise.",
                items: ["Objetivo PR: mínimo 20 propuestas, que dependen de la aprobación de la empresa; Narwhal cubre el end to end: pitch, seguimiento, cierre con el medio seleccionado y monitoreo de resultados.", "3 webinars semestrales con referentes del sector: convocatoria, curaduría editorial, gestión técnica, moderación y amplificación completa post-evento."],
              },
              {
                icon: "calendar",
                title: "Eventos del sector",
                text: "Presencia en los espacios donde está tu industria.",
                items: ["3 eventos digitales: producción, convocatoria, gestión técnica, moderación y amplificación completa post-evento.", "Scouting de eventos del sector: mapeo de conferencias, foros y encuentros donde la empresa podría participar como speaker, panelista o sponsor.", "Análisis de qué eventos tienen sentido sponsorear versus participar sin inversión adicional."],
              },
              {
                icon: "community",
                title: "Community Building",
                text: "Relaciones que generan oportunidades.",
                items: ["Cada webinar genera contenido audiovisual reutilizable en LinkedIn, newsletter, outbound y blogs.", "Narwhal gestiona el contacto con organizadores, y presenta propuestas concretas para que el equipo de la empresa decida dónde participar. Los costos de sponsoreo no están incluidos."],
              },
            ],
          },
          metrics: {
            kicker: "Métricas esperadas",
            title: "Volumen comprometido en 6 meses",
            subtitle: "Los entregables concretos que nos comprometemos a alcanzar durante el período.",
            cards: [
              { icon: "file", value: "30", label: "propuestas de aparición en medios", sub: "Todo el período" },
              { icon: "users", value: "100", label: "contactos en base de referentes", sub: "Mes 1–2" },
              { icon: "news", value: "3", label: "notas publicadas en medios", sub: "Mes 2–4" },
              { icon: "calendar", value: "2 + 10", label: "mapeos + oportunidades activas en eventos", sub: "Por trimestre" },
              { icon: "mic", value: "3", label: "webinars virtuales gestionados end to end", sub: "Semestral" },
              { icon: "play", value: "+12", label: "piezas de contenido por evento", sub: "Por cada evento" },
              { icon: "lead", value: "10 – 30", label: "leads calificados por webinar", sub: "Por evento" },
              { icon: "link", value: "8 – 20", label: "backlinks de calidad por notas y menciones", sub: "Todo el período" },
            ],
          },
          cta: "Hablemos de este módulo",
        },
      },
    ],
  },
  en: {
    kicker: "Services",
    allLabel: "All services",
    cta: "Book a call",
    activateTitle: "Want to activate this service?",
    fee: {
      label: "One single monthly fee",
      amount: "USD 3,200",
      per: "/mo",
      checks: ["No retainer or minimum terms.", "A complete team, ready to operate.", "+8 strategies running in sync.", "Tools, processes and reporting included."],
      cta: "I want my strategic review",
    },
    labels: { objetivo: "Goal", incluye: "Includes", noIncluye: "Doesn't include", areas: "The four practices + Direction", areasIntro: "Each area has its own strategies, deliverables and scope, all aligned under a single Business Direction so the whole moves as one ecosystem, not as scattered initiatives.", orgHint: "Tap each area to see what's included", anterior: "Previous", siguiente: "Next" },
    comingSoon: "We're preparing the details of this service. Reach out to learn the full scope.",
    list: [
      {
        slug: "direccion-de-negocios",
        shortName: "Business Direction",
        name: "B2B Business Direction as a Service",
        badge: "Minimum Viable B2B Ecosystem",
        titleMain: "Business Direction",
        titleAccent: "B2B as a Service",
        intro: "A senior team with a single goal: accelerate your B2B growth without having to build the whole structure from scratch.",
        stats: [
          { icon: "users", label: "+15 professionals" },
          { icon: "layers", label: "4 practices" },
          { icon: "compass", label: "Business Direction" },
          { icon: "cpu", label: "Tech stack" },
        ],
        phases: {
          title: "How it matures over time",
          intro: "What is planted on day one matures over the short, medium and long term.",
          items: [
            { icon: "zap", term: "Short term", title: "Activation", text: "We break the inertia: every initiative runs in parallel within the first 15 days, with an initial adjustment cycle and visible results." },
            { icon: "chart", term: "Medium term", title: "Optimization", text: "The first signals from each strategy appear. We iterate with real feedback: better indicators, a more advanced pipeline and first appearances in AI engines." },
            { icon: "trending", term: "Long term", title: "Scalability", text: "Everything more organized and with concrete metrics: we know what works best and where to invest to keep refining the process." },
          ],
        },
        callouts: [
          { icon: "sparkles", title: "The learning stays", text: "Execution builds proprietary indicators, real market understanding and a month-to-month iteration cycle. Each front improves over time instead of starting from scratch." },
          { icon: "compass", title: "One direction, one fee", text: "Everything runs in parallel and coordinated, not as scattered initiatives. A single fee covers the entire commercial front; the client decides what to activate and what to complement with their team." },
        ],
        rhythm: {
          title: "Visibility and work rhythm",
          text: "The whole ecosystem runs with full, real-time visibility:",
          items: [
            "Daily communication with the team",
            "Ad hoc meetings when something specific needs unblocking",
            "Weekly activity reports",
            "Biweekly sessions to iterate strategy with the client",
            "Monthly reporting meeting: results and next steps",
          ],
        },
        areas: [
          {
            icon: "compass",
            name: "Business Direction",
            objetivo:
              "Hold the B2B commercial strategy as a whole: keep the four practices aligned under one criterion, make the whole coherent end to end, and adjust direction with what the market shows.",
            incluye: [
              "Constant review that each front is progressing and none is left unattended",
              "Alignment across practices so nothing competes or overlaps",
              "Market, competitor and industry trend analysis",
              "Detection of gaps and uncovered opportunities",
              "Evaluation of new strategies as the business or context requires",
              "Adjustment of the overall strategy with the client in biweekly sessions",
              "Daily communication with the team",
              "Ad hoc meetings when something specific needs unblocking",
              "Weekly activity reports",
              "Monthly reporting meeting: results and next steps",
            ],
            noIncluye:
              "Defining the company's strategic direction or its macro business objectives: that remains the company's responsibility.",
          },
          {
            icon: "target",
            name: "Business Development ABM",
            objetivo:
              "Generate and manage B2B commercial opportunities systematically, combining multichannel outbound prospecting with inbound demand management.",
            incluye: [
              "Database scraping and enrichment",
              "Multichannel prospecting (LinkedIn, email, WhatsApp): +400 new contacts per month and a target of 2,000 unique contacts in 6 months",
              "Management of up to 50 inbound leads per month, including what comes from content, marketing and SEO",
              "Documentation of processes, databases and assets such as purchased domains",
              "Weekly activity and results reporting",
              "Management of every conversation up to the meeting",
              "Logging of every conversation",
              "Building briefs for the meeting",
            ],
            noIncluye:
              "Cold calls, participation in commercial meetings or closing opportunities: those remain the responsibility of the client's sales team.",
            note: {
              label: "Stays with the company",
              text: "Everything documented, built or bought in this practice (processes, databases, domains) is the client's asset, not Narwhal's.",
            },
          },
          {
            icon: "megaphone",
            name: "Communication & Positioning",
            objetivo:
              "Support commercial development with content that builds clarity, trust and real sales support in long cycles with multiple decision-makers, and sustain brand presence in search and AI engines. It doesn't replace the client's marketing team or define the overall brand strategy.",
            incluye: [
              "Communication axes aligned with the ICP and value proposition, with keywords to rank in search and AI engines",
              "A commercial one-pager",
              "2 strategic blog posts per month, published on the website and LinkedIn",
              "A monthly email newsletter and a LinkedIn one, republished on the blog",
              "4 to 6 monthly pieces for corporate LinkedIn and 4 to 6 for a commercial leader's profile",
              "Videos uploaded to YouTube as part of positioning and republished on Meta",
              "Design support for specific pieces (commercial PPTs, brochures, video editing) subject to availability",
              "Prompt monitoring in ChatGPT, Gemini and Perplexity: how and when the brand appears and who they recommend",
              "On-demand requests (flyers, infographics, case studies) with 15 days' notice",
            ],
            noIncluye:
              "Advanced professional audiovisual production, active engagement management (replies, comments, DMs) or long-term institutional branding strategy.",
            note: {
              label: "Scope",
              text: "It's a deliberately focused strategy, sustained on trends and constant presence, not a large-scale institutional branding campaign. Design support depends on team availability but covers basic demand well.",
            },
          },
          {
            icon: "chart",
            name: "Marketing ABM",
            objetivo:
              "Reinforce presence, capture intent signals and accelerate opportunities through segmented paid campaigns and a solid technical SEO base. It doesn't generate indiscriminate lead volume or replace sales.",
            incluye: [
              "Media strategy aligned with the ICP and commercial narrative",
              "Setup and validation of pixels, Google Analytics and conversion events",
              "Tracking integration with the CRM",
              "Campaigns on Meta Ads (acquisition and remarketing) and Google Ads (Performance Max and Search, including competitor terms)",
              "Up to 8 active campaigns simultaneously",
              "5 graphic creatives and 3 short videos",
              "Technical SEO improvements (schemas, FAQs, landing adjustments)",
              "Metrics tracking via Google Analytics and Search Console",
              "Biweekly review and monthly report",
            ],
            noIncluye:
              "LinkedIn Ads (quoted separately), massive unqualified lead generation, large-scale branding or advanced SEO (backlinks, large-scale domain authority): the focus is a solid technical base. Media spend (USD 300 to 500 per month recommended) is covered by the client and not included in the fee.",
          },
          {
            icon: "cpu",
            name: "Tech, Data & Performance",
            objetivo:
              "Ensure the whole digital commercial ecosystem is enabled, configured, measured and running without friction, so the rest of the practices can execute with real visibility. It doesn't replace the client's tech or IT team.",
            incluye: [
              "Review and setup of domain, web environment, security certificates and commercial contact points (forms, chat, WhatsApp, widgets)",
              "Management and configuration of key tech licenses (CRM, automation, outreach)",
              "Connection and validation of domains, email accounts and access",
              "Continuous monitoring to detect opportunities and risks",
              "Small website improvements when needed",
            ],
            noIncluye:
              "Execution of large-scale technical projects: the role is to monitor and organize, not to build infrastructure from scratch.",
          },
        ],
      },
      {
        slug: "comunicacion-institucional",
        shortName: "Authority & Content",
        name: "Authority, Content & Digital Presence",
        badge: "Module 2",
        variant: "authority",
        titleMain: "Authority, Content",
        titleAccent: "& Digital Presence",
        intro: "We build on what was created in Layer 1, increasing frequency, depth and formats to turn the company's communication into an authority asset.",
        intro2: "Based on the knowledge generated, we expand the strategy to build greater presence, recognition and trust in the market.",
        subcopy: "More content. More formats. More impact. So your company becomes more visible, recognized and trusted in the market.",
        heroCta: "I want to boost my presence",
        floatLabels: ["Content", "Formats", "Assets", "Trends", "Authority"],
        heroNote: "From internal knowledge to market recognition.",
        complement: {
          kicker: "How it complements",
          layers: [
            { tag: "Layer 1", title: "Commercial Development", text: "Generates conversations and opportunities in the short term." },
            { tag: "Layer 2", title: "Authority, Content & Presence", text: "Builds a stronger, more trusted presence that boosts every opportunity." },
          ],
        },
        scope: {
          kicker: "Our scope",
          title: "More content. More depth. More value.",
          intro: "We evolve the content strategy to build a more solid presence, with greater impact and relevance in the market.",
          columns: [
            {
              icon: "file",
              title: "Content evolution",
              text: "We move from a constant presence to a deeper, more sophisticated content strategy.",
              items: ["Higher publishing frequency", "New narratives and formats", "Audiovisual content", "Deeper pieces", "Content adapted to each channel"],
            },
            {
              icon: "layers",
              title: "Authority assets",
              text: "We turn internal knowledge into resources that strengthen the perception of expertise.",
              items: ["Whitepapers", "Downloadable guides", "Case studies", "Proprietary studies and reports", "Reference materials for the market"],
            },
            {
              icon: "trending",
              title: "Always On & Trends",
              text: "We build an active, proactive presence around the market's relevant conversations.",
              items: ["Trend identification", "New content opportunities", "Participation in strategic topics", "Fast reaction to relevant events", "Continuous evolution of the narrative"],
            },
          ],
        },
        result: {
          kicker: "The result",
          title: "From communicating to building authority.",
          text: "A more frequent, deeper and more strategic presence that increases market trust and strengthens every commercial opportunity.",
          cards: [
            { icon: "users", title: "Greater brand recognition" },
            { icon: "shield", title: "More trust in the market" },
            { icon: "chart", title: "More impact on every opportunity" },
          ],
          cta: "I want to boost my presence",
        },
      },
      {
        slug: "seo-geo-aeo",
        shortName: "SEO / GEO / AEO",
        name: "SEO / AEO / GEO + Digital Authority",
        badge: "Module 3",
        variant: "authority",
        titleMain: "SEO / AEO / GEO",
        titleAccent: "+ Digital Authority",
        intro: "We make your company found, understood and recognized by traditional search engines and AI engines.",
        intro2: "We build a digital authority layer combining SEO strategy, specialized content, proprietary assets and external presence to increase organic visibility and generate new opportunities.",
        subcopy: "More organic visibility. More authority. More opportunities.",
        heroCta: "I want more visibility",
        floatLabels: ["SEO", "AEO", "GEO", "Content", "Authority"],
        heroNote: "Found, understood and chosen on Google and AI engines.",
        commitment: {
          scope: {
            kicker: "Scope",
            title: "What this module includes",
            subtitle: "Everything we execute to build organic authority and presence across traditional and AI search engines.",
            columns: [
              {
                icon: "search",
                title: "SEO / AEO / GEO strategy",
                text: "Where to compete and how to build presence.",
                items: ["Quarterly SEO + AEO + GEO plan: strategy, proactive monitoring, measurement, corrections and constant iteration. Ongoing process.", "Monitoring tools included."],
              },
              {
                icon: "file",
                title: "Authority content",
                text: "Content that ranks and captures demand.",
                items: ["Strategic blogs (around 40 over the semester), at a sustained pace and optimized for traditional search and AI engines."],
              },
              {
                icon: "link",
                title: "External authority",
                text: "Signals that strengthen your domain.",
                items: ["Technical backlink and link-building work to build domain authority in a sustained way.", "Opening and optimization of profiles on Wikipedia, Reddit, Crunchbase, Google My Business and relevant sector portals."],
              },
              {
                icon: "settings",
                title: "Web & technical",
                text: "Infrastructure ready to scale.",
                items: ["Migration of the blog from subdomain to main domain to consolidate SEO authority.", "Web technical adjustments to improve performance, load speed, conversion and user experience."],
              },
            ],
          },
          metrics: {
            kicker: "Expected metrics",
            title: "Minimum estimated range over 6 months",
            subtitle: "The minimum estimated range we project to reach during the period.",
            cards: [
              { icon: "settings", value: "2", label: "full technical audits with fixes and monthly optimized content", sub: "Month 6" },
              { icon: "search", value: "Up to 5", label: "competitors monitored and gap analysis in AEO/GEO", sub: "Full period" },
              { icon: "trending", value: "+60% – 120%", label: "organic web traffic growth over current baseline", sub: "Month 4–6" },
              { icon: "chart", value: "15", label: "new keywords ranking on page 1 (minimum)", sub: "Month 3–6" },
              { icon: "sparkles", value: "3 – 5", label: "key topics with sustained appearances in AI Overviews (GEO/AEO)", sub: "Month 3–5" },
              { icon: "news", value: "30 – 40", label: "blogs indexed with their own traffic (of 40 published)", sub: "Month 4–6" },
              { icon: "lead", value: "+15% – 30%", label: "improvement in web conversion rate (post adjustments)", sub: "Month 2–3" },
              { icon: "link", value: "20 – 30", label: "quality backlinks generated", sub: "Full period" },
              { icon: "check", value: "Completed", label: "migration of the blog to the main domain", sub: "Urgent" },
            ],
          },
          cta: "I want more visibility",
        },
      },
      {
        slug: "pr-y-eventos",
        shortName: "PR & Events",
        name: "PR + Webinars + Community Building",
        badge: "Module 4",
        variant: "authority",
        titleMain: "PR + Webinars",
        titleAccent: "+ Community Building",
        intro: "We build institutional authority and market presence through public relations, strategic events and spaces where industry leaders take part.",
        subcopy: "More recognition. More authority. More opportunities.",
        heroCta: "I want to build presence",
        floatLabels: ["PR", "Media", "Webinars", "Events", "Community"],
        heroNote: "Where you show up, who you connect with and the place you hold in your ecosystem.",
        complement: {
          kicker: "How it complements",
          layers: [
            { tag: "Layer 1", title: "Commercial Development", text: "The commercial layer generates movement and opens conversations." },
            { tag: "Layer 2", title: "PR, Events & Community", text: "Amplifies the movement with presence and reputation in the market." },
          ],
          intro: "In B2B, trust is built not only by what a company communicates, but also by where it shows up, who it connects with and the place it holds within its ecosystem. Narwhal develops an external presence strategy to increase recognition, generate exposure opportunities and position the company in front of clients, partners and industry leaders.",
          caption: "While Commercial Development opens conversations, this layer increases the company's credibility and visibility within the market.",
        },
        commitment: {
          scope: {
            kicker: "Scope",
            title: "What this module includes",
            subtitle: "The detail of everything we execute and manage to build your external presence.",
            columns: [
              {
                icon: "megaphone",
                title: "PR & Media",
                text: "Visibility in relevant outlets of the sector.",
                items: ["Media plan: definition of strategy and priority, specialized outlets. Roadmap.", "Narwhal acts as an internal PR area: scouting of relevant outlets, building a database of journalists and relevant publications, tracking dashboards and active relationship management. The cost of publishing in paid media is not included."],
              },
              {
                icon: "mic",
                title: "Webinars",
                text: "Spaces to position your expertise.",
                items: ["PR goal: minimum 20 proposals, subject to the company's approval; Narwhal covers end to end: pitch, follow-up, closing with the selected outlet and results monitoring.", "3 biannual webinars with industry leaders: outreach, editorial curation, technical management, moderation and full post-event amplification."],
              },
              {
                icon: "calendar",
                title: "Sector events",
                text: "Presence in the spaces where your industry is.",
                items: ["3 digital events: production, outreach, technical management, moderation and full post-event amplification.", "Sector event scouting: mapping of conferences, forums and gatherings where the company could take part as speaker, panelist or sponsor.", "Analysis of which events are worth sponsoring versus participating without additional investment."],
              },
              {
                icon: "community",
                title: "Community Building",
                text: "Relationships that generate opportunities.",
                items: ["Each webinar generates reusable audiovisual content on LinkedIn, newsletter, outbound and blogs.", "Narwhal manages contact with organizers, and presents concrete proposals so the company's team decides where to participate. Sponsorship costs are not included."],
              },
            ],
          },
          metrics: {
            kicker: "Expected metrics",
            title: "Committed volume over 6 months",
            subtitle: "The concrete deliverables we commit to reaching during the period.",
            cards: [
              { icon: "file", value: "30", label: "media appearance proposals", sub: "Full period" },
              { icon: "users", value: "100", label: "contacts in the base of leaders", sub: "Month 1–2" },
              { icon: "news", value: "3", label: "articles published in media", sub: "Month 2–4" },
              { icon: "calendar", value: "2 + 10", label: "maps + active opportunities in events", sub: "Per quarter" },
              { icon: "mic", value: "3", label: "virtual webinars managed end to end", sub: "Biannual" },
              { icon: "play", value: "+12", label: "content pieces per event", sub: "Per event" },
              { icon: "lead", value: "10 – 30", label: "qualified leads per webinar", sub: "Per event" },
              { icon: "link", value: "8 – 20", label: "quality backlinks from articles and mentions", sub: "Full period" },
            ],
          },
          cta: "Let's talk about this module",
        },
      },
    ],
  },
};
